import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchAirlineComponent } from './search-airline.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [SearchAirlineComponent],
  imports: [CommonModule, NgSelectModule, FormsModule, TranslateModule, ReactiveFormsModule],
  exports: [SearchAirlineComponent]
})
export class SearchAirlineModule { }
